import { sanitizeAISpeak } from "../utils/chat-ai-message";
import { OPENAI_AUDIO_URL, getAudioSpeech } from "../utils/openAI-utils";
import { findAncestorWithComponent } from "../utils/scene-graph";
import configs from "../utils/configs";
import { isIOS } from "../utils/is-mobile";
import { proxiedUrlFor } from "../utils/media-url-utils";
import { upload } from "../utils/media-utils";
AFRAME.registerComponent("npc-avatar", {
  schema: {
    name: { type: "string" },
    assistant: { type: "string" },
    apiKey: {type: "string", default: ""}
  },
  init() {
    this.npcId = '';
    this.apiKey = '';
    this.mixerEl = findAncestorWithComponent(this.el, "animation-mixer");
    this.el.addEventListener('ai-message', this.aiTalk.bind(this)); 
    this.messageDispatch = window.APP.messageDispatch;
    this.threadId = null;
    this.audioEl = AFRAME.scenes[0].systems['npc-audio'].audioEl;
    this.el.appendChild(this.audioEl);
    this.assistantId = this.data.assistant;
    this.speakerBotUI = null;
    this.analyser = null;
    this.isTalking = false;
    this.recording = false;

    this.el.setAttribute("loop-animation", "paused", true);
    this.el.setAttribute("ai-proximity-audio", { distance: 3});
  },
  update() {
      this.npcId = this.data.name;
      this.apiKey = this.data.apiKey;
  },
  async urlToBlob(url) {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const blob = await response.blob();
    return blob;
  },

  async renderImageUser(url) {
    const proxiedUrlBody = proxiedUrlFor(url);
    const entry = {
      name: proxiedUrlBody,
      path: proxiedUrlBody,
      public_thumbnail: proxiedUrlBody,
      type: 'image',
      thumbnail: proxiedUrlBody,
      url: proxiedUrlBody,
    }

    const file = await this.urlToBlob(proxiedUrlBody);
    const response = await upload(file, "image/png");

    window.APP.store.update({
      uploadPromotionTokens: [{ fileId: response.file_id, promotionToken: response.meta.promotion_token }]
    });

    entry.url = response.origin + `?token=${response.meta.access_token}`;

    window.APP.scene.emit("add_media", {
      src: entry.url || file
    });
  },

  async aiTalk(event) {
    const {body: aiMessage, audio, messageDispatch, voiceMode} = event?.detail;

    this.messageDispatch.dispatchEvent(new CustomEvent("ai-cancel-play"));
    if(messageDispatch !== false) {
      this.aiSendPrivateMessage(aiMessage,audio, voiceMode);
    }
    
    if(voiceMode && aiMessage.startsWith('https') && !audio) {
      const showImageAudio = "https://nextrealitydigital.blob.core.windows.net/nrd/metaverse/here-is-theresult.mp3";
      await this.renderImageUser(aiMessage);
      this.playAnyAudio(showImageAudio);
    }

    if(aiMessage.startsWith('https') || !audio) {
      return;
    }

    if(voiceMode) {
      this.mixerEl?.components["animation-mixer"].setPausedComponent(false);
      this.el.setAttribute("loop-animation", { paused: false });
      await new Promise((resolve, reject) => setTimeout(resolve, 100));
      await this.playSpeak(audio);
    }
    

  },
  aiSendPrivateMessage(aiMessage, audio, voiceMode) {
    const type = 'private-chat';
    let play = !!audio;
    if(isIOS()) {
      play = false;
    }

    if(!voiceMode) {
      play = false;
    }

    // this.messageDispatch.dispatchEvent(new CustomEvent("ai-local-message-edit", { 
    //   detail: { type: type, body: { message: aiMessage, receiver: this.npcId, sender: 'Chat GPT' , play, audio} } 
    // }));
  },
  onEndAudio() {
    const audioEl = this.audioEl;
    if (audioEl) {
      if(!this.el.components["loop-animation"].data.paused) {
        this.mixerEl?.components["animation-mixer"].setPausedComponent(true);
        this.el.components["loop-animation"].stopAnimation();
      }
      audioEl.pause()
      this.messageDispatch.dispatchEvent(new CustomEvent("ai-cancel-play"));
    }

    const timeForNextPrompt = 2000 // 2 seconds
    setTimeout(() => {
      this.isTalking = false;
      window.dispatchEvent(new CustomEvent(AGENT_EVENTS.AI_FINISH_SPEAK));
    }, timeForNextPrompt)
  },
  async playSpeak(audio) {
    const OPENAI_API = configs['CUSTOM_API_URL'] + '/v1/ai';

    const urlSpeech = proxiedUrlFor(`${OPENAI_AUDIO_URL}/${audio}`);

    return new Promise((resolve, reject) => {
      this.audioEl.src = urlSpeech;
      this.audioEl.autoplay = true;
      this.audioEl.onended = () => {
        this.onEndAudio();
        resolve();
      }

      const checkEnded = () => {
          if (this.audioEl.ended) {
              this.audioEl.removeEventListener('timeupdate', checkEnded);
              this.onEndAudio();
              resolve();
          }
      };
      this.audioEl.addEventListener('timeupdate', checkEnded);
    });
  },
  async playAnyAudio(url) {
    this.isTalking = true;
    const urlSpeech = proxiedUrlFor(url);

    return new Promise((resolve, reject) => {
      this.audioEl.src = urlSpeech;
      this.audioEl.autoplay = true;
      this.audioEl.onended = () => {
        this.onEndAudio();
        resolve();
      }

      const checkEnded = () => {
          if (this.audioEl.ended) {
              this.audioEl.removeEventListener('timeupdate', checkEnded);
              this.onEndAudio();
              resolve();
          }
      };
      this.audioEl.addEventListener('timeupdate', checkEnded);
    });
  },

  async playSpeakWelcome() {
    this.isTalking = true;
    const urlSpeech = proxiedUrlFor("https://nextrealitydigital.blob.core.windows.net/nrd/metaverse/hello-ai-npc.mp3");

    return new Promise((resolve, reject) => {
      this.audioEl.src = urlSpeech;
      this.audioEl.autoplay = true;
      this.audioEl.onended = () => {
        this.onEndAudio();
        resolve();
      }

      const checkEnded = () => {
          if (this.audioEl.ended) {
              this.audioEl.removeEventListener('timeupdate', checkEnded);
              this.onEndAudio();
              resolve();
          }
      };
      this.audioEl.addEventListener('timeupdate', checkEnded);
    });
  },
  onEndAudioWelcome() {
    const audioEl = this.audioEl;
    if (audioEl) {
      if(!this.el.components["loop-animation"].data.paused) {
        this.mixerEl?.components["animation-mixer"].setPausedComponent(true);
        this.el.components["loop-animation"].stopAnimation();
      }
      this.messageDispatch.dispatchEvent(new CustomEvent("ai-cancel-play"));
    }

    this.isTalking = false;
  },
  playBlankAudio() {
    this.audioEl.src = '#';
    this.audioEl.autoplay = true;
  },
  errorRecording() {
    this.isTalking = true;
    const urlSpeech = proxiedUrlFor("https://nextrealitydigital.blob.core.windows.net/nrd/metaverse/error-handler-npc.mp3");

    return new Promise((resolve, reject) => {
      this.audioEl.src = urlSpeech;
      this.audioEl.autoplay = true;
      this.audioEl.onended = () => {
        this.onEndAudio();
        resolve();
      }

      const checkEnded = () => {
          if (this.audioEl.ended) {
              this.audioEl.removeEventListener('timeupdate', checkEnded);
              this.onEndAudio();
              resolve();
          }
      };
      this.audioEl.addEventListener('timeupdate', checkEnded);
    });
  }
});
